<template>
  <div class="text-md-right">
    <a
      @click="openModal('#' + modalId)"
    >
      <img
        :src="smallSrc"
        class="usage-sm-image hoverable"
      >
    </a>
    <div
      :id="modalId"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pic_of_resume_modal"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl"
        role="document"
      >
        <div
          class="modal-content"
          data-dismiss="modal"
          @click="closeModal('#' + modalId)"
        >
          <div class="modal-body h-100">
            <img
              :src="largeSrc"
              class="usage-lg-image"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modalId: {
      type: String,
      required: true
    },
    smallImage: {
      type: String,
      required: true
    },
    largeImage: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      smallSrc: require(`../../../../../app/assets/images/admin/${this.smallImage}`),
      largeSrc: require(`../../../../../app/assets/images/admin/${this.largeImage}`)
    };
  },
  methods: {
    openModal(id) {

      // モーダルを開く
      $(id).modal();
    },
    closeModal(id) {

      // モーダルを閉じる
      $(id).modal();
    }
  }
};
</script>

<style scoped>
.usage-sm-image {
  border: 1px solid rgba(0, 0, 0, 0.125);
  width: 360px;
  height: 240px;
}
@media (max-width: 767px) {
  .usage-sm-image {
    width: 333px;
    height: 222px;
  }
}
.usage-lg-image {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.modal-body {
  padding: 0;
}
</style>
